import React, { useState } from 'react';
import { useConfig } from '../context/ConfigContext';

const Footer = ({ pageKey }) => {
    const { config } = useConfig();
    const [cacheBuster] = useState(() => Date.now());

    const getCleanImageUrl = (url) => {
        if (!url) return '';
        return `${url}${url.includes('?') ? '&' : '?'}v=${cacheBuster}`;
    };

    const pageDesign = config?.pageDesigns?.[pageKey] || {};
    const footerMode = config?.footerMode || 'center';

    if (footerMode === 'split') {
        const leftUrl = config?.footerLogoLeftUrl ? getCleanImageUrl(config.footerLogoLeftUrl) : '';
        const rightUrl = config?.footerLogoRightUrl ? getCleanImageUrl(config.footerLogoRightUrl) : '';

        if (!leftUrl && !rightUrl) return null;

        return (
            <footer className="w-full p-4 sm:p-6 flex-shrink-0 flex justify-between items-center z-40 select-none bg-transparent gap-4 max-w-7xl mx-auto">
                {leftUrl ? (
                    <img
                        src={leftUrl}
                        alt="Footer Logo Left"
                        className="max-w-[40vw] md:max-w-xs max-h-[80px] sm:max-h-[100px] h-auto object-contain pointer-events-none"
                        onError={(e) => { e.target.style.display = 'none'; }}
                    />
                ) : <div />}
                {rightUrl ? (
                    <img
                        src={rightUrl}
                        alt="Footer Logo Right"
                        className="max-w-[40vw] md:max-w-xs max-h-[80px] sm:max-h-[100px] h-auto object-contain pointer-events-none"
                        onError={(e) => { e.target.style.display = 'none'; }}
                    />
                ) : <div />}
            </footer>
        );
    }

    const singleUrl = getCleanImageUrl(config?.footerLogoUrl || (pageDesign?.showLegalText ? pageDesign?.legalTextUrl : ''));
    if (!singleUrl) return null;

    return (
        <footer className="w-full p-4 sm:p-6 flex-shrink-0 flex justify-center items-center z-40 select-none bg-transparent max-w-7xl mx-auto">
            <img
                src={singleUrl}
                alt="Footer Logo"
                className="max-w-[85vw] sm:max-w-md md:max-w-xl max-h-[100px] sm:max-h-[120px] w-auto h-auto object-contain pointer-events-none mx-auto"
                onError={(e) => { e.target.style.display = 'none'; }}
            />
        </footer>
    );
};

export default Footer;
